import * as $runtime from "../runtime.js";
import * as Control$dSemigroupoid from "../Control.Semigroupoid/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const fromFoldable = /* #__PURE__ */ Foreign$dObject.fromFoldable(Data$dFoldable.foldableArray);
const genericDecodeManyArgsArgu = dictDecode => ({argsDecoder: Data$dTuple.$Tuple(1, offset => array => dictDecode.unsafeDecode(Data$dArray.unsafeIndexImpl(array, offset)))});
const genericDecodeArgsNoArgume = {genericDecodeArgs: v => Data$dGeneric$dRep.NoArguments};
const genericDecodeArgsArgument = dictDecode => ({genericDecodeArgs: x => dictDecode.unsafeDecode(x)});
const decodeSingleConstructorAr = () => dictDecodeRecord => ({unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(dictDecodeRecord.recordInfo(Type$dProxy.Proxy))});
const unwrapContents = x => x.contents;
const decodeSingleConstructorAr1 = dictDecode => ({unsafeDecodeSingleConstructorArgument: x => dictDecode.unsafeDecode(x.contents)});
const unsafeDecodeSingleConstructorArgument = dict => dict.unsafeDecodeSingleConstructorArgument;
const genericDecodeSumConstruct = dictIsSymbol => dictDecodeSingleConstructorArgument => (
  {
    genericSumDecoder: _opts => [
      Data$dTuple.$Tuple(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy), x => dictDecodeSingleConstructorArgument.unsafeDecodeSingleConstructorArgument(x))
    ]
  }
);
const genericSumDecoder = dict => dict.genericSumDecoder;
const genericDecodeSumSum = dictGenericDecodeSum => dictGenericDecodeSum1 => (
  {
    genericSumDecoder: opts => Data$dSemigroup.concatArray(Data$dFunctor.arrayMap(Data$dTuple.functorTuple.map(Control$dSemigroupoid.semigroupoidFn.compose(Data$dGeneric$dRep.Inl)))(dictGenericDecodeSum.genericSumDecoder(opts)))(Data$dFunctor.arrayMap(Data$dTuple.functorTuple.map(Control$dSemigroupoid.semigroupoidFn.compose(Data$dGeneric$dRep.Inr)))(dictGenericDecodeSum1.genericSumDecoder(opts)))
  }
);
const genericDecoder = dict => dict.genericDecoder;
const genericUnsafeDecode = dictGeneric => dictGenericDecode => opts => {
  const $0 = dictGenericDecode.genericDecoder(opts);
  return x => dictGeneric.to($0(x));
};
const genericDecodeTaggedSumType = dictGenericDecodeSum => opts => {
  const constructors = fromFoldable(dictGenericDecodeSum.genericSumDecoder(opts));
  return value => {
    const tag = Unscramble.decodeString(Unscramble.expectObject(value).tag);
    const v = Foreign$dObject._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, tag, constructors);
    if (v.tag === "Nothing") { return Unscramble.decodingError("Invalid sum type tag: " + Data$dShow.showStringImpl(tag)); }
    if (v.tag === "Just") { return v._1(value); }
    $runtime.fail();
  };
};
const genericUnsafeDecodeTagged = dictGeneric => dictGenericDecodeSum => opts => {
  const $0 = genericDecodeTaggedSumType(dictGenericDecodeSum)(opts);
  return x => dictGeneric.to($0(x));
};
const genericDecode = dictGenericDecodeSum => ({genericDecoder: genericDecodeTaggedSumType(dictGenericDecodeSum)});
const genericDecodeArgs = dict => dict.genericDecodeArgs;
const genericDecodeConstructor = dictGenericDecodeArgs => ({genericDecoder: opts => x => dictGenericDecodeArgs.genericDecodeArgs(x)});
const genericDecodeSumConstruct1 = dictGenericDecodeArgs => dictIsSymbol => (
  {genericSumDecoder: _opts => [Data$dTuple.$Tuple(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy), x => dictGenericDecodeArgs.genericDecodeArgs(x.contents))]}
);
const defaultOptions = {};
const argsDecoder = dict => dict.argsDecoder;
const genericDecodeArgs1 = dictGenericDecodeManyArgs => (
  {
    genericDecodeArgs: (() => {
      const $0 = dictGenericDecodeManyArgs.argsDecoder._1;
      return value => {
        const array = Unscramble.expectArray(value);
        if (array.length === $0) { return dictGenericDecodeManyArgs.argsDecoder._2(0)(array); }
        return Unscramble.decodingError("Invalid number of constructor arguments");
      };
    })()
  }
);
const genericDecodeManyArgsProd = dictGenericDecodeManyArgs => {
  const argsDecoder1 = dictGenericDecodeManyArgs.argsDecoder;
  return dictGenericDecodeManyArgs1 => (
    {
      argsDecoder: (() => {
        const $0 = argsDecoder1._1;
        return Data$dTuple.$Tuple(
          $0 + dictGenericDecodeManyArgs1.argsDecoder._1 | 0,
          offset => array => Data$dGeneric$dRep.$Product(argsDecoder1._2(offset)(array), dictGenericDecodeManyArgs1.argsDecoder._2(offset + $0 | 0)(array))
        );
      })()
    }
  );
};
export {
  argsDecoder,
  decodeSingleConstructorAr,
  decodeSingleConstructorAr1,
  defaultOptions,
  fromFoldable,
  genericDecode,
  genericDecodeArgs,
  genericDecodeArgs1,
  genericDecodeArgsArgument,
  genericDecodeArgsNoArgume,
  genericDecodeConstructor,
  genericDecodeManyArgsArgu,
  genericDecodeManyArgsProd,
  genericDecodeSumConstruct,
  genericDecodeSumConstruct1,
  genericDecodeSumSum,
  genericDecodeTaggedSumType,
  genericDecoder,
  genericSumDecoder,
  genericUnsafeDecode,
  genericUnsafeDecodeTagged,
  unsafeDecodeSingleConstructorArgument,
  unwrapContents
};
